export const MEASURING_UNITS = [
  { value: 'bags', label: 'Bags' },
  { value: 'tons', label: 'Tons' },
  { value: 'grams', label: 'Grams' },
  { value: 'pounds', label: 'Pounds' },
  { value: "litres", label: "Litres" },
  { value: "kilograms", label: "Kilograms" },
]

export const DEFAULT_MEASURING_UNIT = 'tons'

export const getMeasuringUnitLabel = (unit) => {
  const normalized = (unit || DEFAULT_MEASURING_UNIT).toLowerCase()
  return MEASURING_UNITS.find((item) => item.value === normalized)?.label || normalized
}

export const getHarvestQuantity = (request) =>
  request?.quantity ?? request?.weight_in_tons ?? null

export const getHarvestPrice = (request) =>
  request?.price ?? request?.price_per_ton ?? null

export const getMeasuringUnitDisplay = (request) => {
  if (request?.measuring_unit_display) return request.measuring_unit_display
  if (typeof request === 'string') return getMeasuringUnitLabel(request).toLowerCase()
  return getMeasuringUnitLabel(request?.measuring_unit).toLowerCase()
}

export const formatHarvestNumber = (value) => {
  if (value == null || value === '') return null
  const num = Number(value)
  if (Number.isNaN(num)) return null
  return num.toLocaleString(undefined, { maximumFractionDigits: 2 })
}

export const formatHarvestQuantityDisplay = (request) => {
  const quantity = getHarvestQuantity(request)
  if (quantity == null) return 'N/A'
  return `${formatHarvestNumber(quantity)} ${getMeasuringUnitDisplay(request)}`
}

export const formatHarvestPriceDisplay = (request) => {
  const price = getHarvestPrice(request)
  if (price == null) return 'N/A'
  return `GHS ${formatHarvestNumber(price)}/${getMeasuringUnitDisplay(request)}`
}

export const formatHarvestEstimatedValue = (request) => {
  if (request?.total_estimated_value != null) {
    return `GHS ${formatHarvestNumber(request.total_estimated_value)}`
  }

  const quantity = Number(getHarvestQuantity(request))
  const price = Number(getHarvestPrice(request))
  if (!Number.isNaN(quantity) && !Number.isNaN(price)) {
    return `GHS ${formatHarvestNumber(quantity * price)}`
  }

  return 'N/A'
}

export const formatHarvestPriceWeightSummary = (request) => {
  const price = getHarvestPrice(request)
  const quantity = getHarvestQuantity(request)
  if (price == null || quantity == null) return 'N/A'
  return `${formatHarvestPriceDisplay(request)} · ${formatHarvestNumber(quantity)} ${getMeasuringUnitDisplay(request)}`
}

export const getWeightFieldLabel = (unitOrRequest) => {
  const unit = typeof unitOrRequest === 'object'
    ? getMeasuringUnitDisplay(unitOrRequest)
    : getMeasuringUnitLabel(unitOrRequest).toLowerCase()
  return `Quantity (${unit})`
}

export const getPriceFieldLabel = (unitOrRequest) => {
  const unit = typeof unitOrRequest === 'object'
    ? getMeasuringUnitDisplay(unitOrRequest)
    : getMeasuringUnitLabel(unitOrRequest).toLowerCase()
  return `Price Per ${unit} (GHS)`
}

export const buildHarvestRequestPayload = ({
  weight,
  price,
  measuringUnit,
  ...rest
}) => {
  const quantity = parseFloat(weight)
  const unitPrice = parseFloat(price)

  const payload = {
    ...rest,
    quantity,
    price: unitPrice,
    measuring_unit: measuringUnit,
    weight_in_tons: quantity,
    price_per_ton: unitPrice,
  }

  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined) delete payload[key]
  })

  return payload
}

export const formatHarvestRequestError = (error) => {
  const data = error?.response?.data
  if (!data) return error?.message || 'Request failed'

  if (typeof data === 'string') return data
  if (data.detail) return data.detail

  const messages = Object.entries(data).flatMap(([field, value]) => {
    if (Array.isArray(value)) return value.map((msg) => `${field}: ${msg}`)
    if (typeof value === 'string') return [`${field}: ${value}`]
    return []
  })

  return messages.length > 0 ? messages.join(', ') : 'Request failed'
}
